import styles from './index.css'
import CommonPage from '../../containers/Proposal/Common/CommonPage'
import { ProposalSection } from '@vzmi/shp_shared_compo'
import HeadingWithId from '../Proposal/Common/HeadingWithId/HeadingWithId'
import Feature from './Feature'
import Introduction from './Introduction'
import { unbindBeforeunload } from '../../components/Proposal/Common/BeforeUnload'
import { useSilentPage } from '../../context/silentPageContext'

const BatchProposalMain = props => {
  const { setSilentPageTo } = useSilentPage()
  setSilentPageTo(true)
  unbindBeforeunload()

  return (
    <div className={styles.topContainer}>
      <HeadingWithId
        title={'批次提案工具'}
        data-role='batch-proposal-header'
      />
      <ProposalSection
        title={'特色'}
        className={styles.proposalSection}
        data-role='batch-proposal-feature'
      >
        <Feature {...props} />
      </ProposalSection>
      <ProposalSection
        title={'安裝與登入步驟'}
        className={styles.proposalSection}
        data-role='batch-proposal-introduction'
      >
        <Introduction {...props} />
      </ProposalSection>
    </div>
  )
}

const BatchProposal = props => {
  return (
    <CommonPage >
      <BatchProposalMain {...props} />
    </CommonPage>
  )
}

export default BatchProposal
